<script setup lang="ts">
    defineProps<{
        a11yLabel?: string;
    }>();
</script>

<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="24"
        height="24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        :role="a11yLabel ? 'img' : 'presentation'"
        :aria-label="a11yLabel"
        :aria-hidden="!a11yLabel"
    >
        <path d="M18 6 6 18" />
        <path d="m6 6 12 12" />
    </svg>
</template>
